import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from "../../../services/session";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            kits: [],
            newKit: ''
        }
    },
    computed : {

    },
    methods: {
        load: load,
        addNewKit: addNewKit,
        deleteKit: deleteKit,
        updateAdditionalKits: updateAdditionalKits,
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.load()
    }
}

function addNewKit(){
    if(this.newKit === '') return;
    if(this.newKit.includes(",")) {
        swal('Greška', "Tip treninga ne moze da sadrzi zarez u imenu.", 'error')
        return;
    }
    this.kits.push('' + this.newKit);
    this.newKit = '';
    this.updateAdditionalKits();
}

function deleteKit(item){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_training_type_are_you_sure_to_delete') + ': ' + item,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        const index = _self.kits.indexOf(item);
        if (index > -1) { // only splice array when item is found
            _self.kits.splice(index, 1); // 2nd parameter means remove one item only
        }
        _self.updateAdditionalKits()
    });
}

function load() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            const fields = [];
            for (let field in response.data) {
                if(field.length > 0){
                    fields.push(field);
                }
            }
            console.log(fields);
            _self.kits = fields;
        })
        .catch(error => {
            console.error(error)
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function updateAdditionalKits(){
    let _self = this;
    let newModel = {
        trainingTypes: this.kits
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte...</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});
    AdminApiService.updateCompanyTrainingTypes(newModel)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_success_update_training_types'), 'success')
            // window.history.go(-1); return false;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Users/Payment/TrainingTypes.js